import { Component, OnInit } from '@angular/core'
import {ChatState} from '../../../core/services/chat.service'
import { SharedDataService } from 'src/app/core/services/shared-data.service'

@Component({
    selector: 'app-side-buttons',
    templateUrl: './side-buttons.component.html',
    styleUrls: ['./side-buttons.component.scss'],
    standalone: false
})
export class SideButtonsComponent implements OnInit {

  constructor(private chatState: ChatState, public sharedDataService: SharedDataService) { }
   activeTemplate: any

  ngOnInit(): void {
    this.activeTemplate = this.sharedDataService.getRoute()
  }

  scrollTop(){
    window.scroll({top: 0, behavior: 'smooth'})
  }

  showChat(){
    this.chatState.toggleChat(true)
  }

}
